/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Project } from "./project";
import { User } from "./user";

/**
 *
 * @export
 * @interface UserCreatedProject
 */
export interface UserCreatedProject {
  /**
   *
   * @type {Project}
   * @memberof UserCreatedProject
   */
  project: Project;
  /**
   *
   * @type {User}
   * @memberof UserCreatedProject
   */
  user: User;
}
